import "./index.scss";
import FeaturedSolutions from "../../components/FeaturedSolutions";
import LogoMini from "../../components/icons/LogoMini";
import InfoGenesis from "../../assets/img/Featured/kiosk-retail.png";
import Eatec from "../../assets/img/Featured/tablet-eatec.png";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useData } from "../../context/DataProvider";
import { useCallback } from "react";
import { Header } from "../../components/Header";
const GasStationPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const navigate = useNavigate();
    return(
        <div className="page splash gasStationPage">
            <div className="background" />
            <Header />
            <div className="page-header">Gas Station / Market</div>
            <div className="text-blocks">
                <div className="std-text">
                    Simplify pump management with POS integration 
                    to seamlessly display a pump management 
                    console for managing pump status and car wash 
                    sales at the POS terminal. And use Agilysys POS 
                    solutions to manage all convenience store sales 
                    with integration to the rest of your property POS 
                    management.
                </div>
            </div>
            <FeaturedSolutions>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Gas Station/Market", "InfoGenesis");
                    addFlow("InfoGenesis");
                    navigate("/solutions/info-genesis")}}>
                    <div className="item-head">
                        <LogoMini />
                        InfoGenesis
                    </div>
                    <img src={InfoGenesis} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Gas Station/Market", "Eatec");
                    addFlow("Eatec");
                    navigate("/solutions/eatec")}}>
                    <div className="item-head">
                        <LogoMini />
                        Eatec
                    </div>
                    <img src={Eatec} alt="" />
                </div>
            </FeaturedSolutions>
        </div>
    )
}
export default GasStationPage;